import { render, staticRenderFns } from "./livestockAdditionToUnit.vue?vue&type=template&id=1f7d8aae&scoped=true&"
import script from "./livestockAdditionToUnit.vue?vue&type=script&lang=js&"
export * from "./livestockAdditionToUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7d8aae",
  null
  
)

export default component.exports